import React from "react";
import { useNavigate } from "react-router";
import { BASE_URL } from "../../../../static/constants";
import getToken from "../../../../utils/getToken";

// Material Imports
import Button from "@mui/material/Button";

// Import CSS
import "./index.css";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

import { showErrorToast } from "utils/toast";
import ModalWrapper from "components/common/modals/modalWrapper/ModalWrapper";
import { Formik } from "formik";
import { FormHelperText } from "@mui/material";
import SubmitButton from "components/Button/SubmitButton";
import { lateRPMValidationSchema } from "schemas/lateRPMValidationSchema";
import { filterNonUCHAccounts } from "utils/account.util";

export default function UserModal(props) {
  const { accounts, latePatientModalOpen, closeLatePatientModal } = props;
  const filteredAccounts = filterNonUCHAccounts(accounts);

  const navigate = useNavigate();

  const onClose = () => {
    closeLatePatientModal();
  };

  const getBillingHistory = (account) => {
    fetch(`${BASE_URL}/v2/patient/export/late`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
      body: JSON.stringify({
        account: account,
      }),
    })
      .then((result) => {
        let newResult;
        if (!result.ok) {
          newResult = result.clone().json();
        } else {
          newResult = result;
        }
        return newResult;
      })
      .then((result) => {
        if (result.error) {
          throw Error(result.message);
        }

        result.blob().then((data) => {
          const file = new Blob([data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          const fileURL = URL.createObjectURL(file);
          let fileName = result.headers
            .get("Content-Disposition")
            .split("=")[1];

          var a = document.createElement("a");
          document.body.appendChild(a);
          a.style = "display: none";
          a.href = fileURL;
          a.download = fileName;
          a.click();
          window.URL.revokeObjectURL(fileURL);
          onClose();
        });
      })
      .catch((error) => {
        const errorStr = error.toString();
        if (errorStr === "Error: jwt malformed") {
          navigate("/login");
        }
        if (errorStr === "Error: jwt expired") {
          navigate("/login");
        }
        if (errorStr === "Error: Unauthorized") {
          navigate("/prohibited");
        }

        showErrorToast(errorStr);
      });
  };

  return (
    <ModalWrapper
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      show={latePatientModalOpen}
      onClose={onClose}
      title="Late Patient List"
    >
      <Formik
        initialValues={{
          account:
            filteredAccounts?.length === 1 ? filteredAccounts?.[0]?.name : "",
        }}
        validationSchema={lateRPMValidationSchema}
        onSubmit={(values) => getBillingHistory(values.account)}
      >
        {({
          handleSubmit,
          handleChange,
          values,
          touched,
          errors,
          isSubmitting,
          resetForm,
        }) => (
          <div>
            <div style={{ marginBottom: "20px", marginTop: "20px" }}>
              <FormControl
                fullWidth
                variant="outlined"
                error={touched.account && Boolean(errors.account)}
              >
                <InputLabel id="issue-label">Select Account</InputLabel>
                <Select
                  id="accounts"
                  value={
                    filteredAccounts?.length > 1
                      ? values.account
                      : filteredAccounts?.[0]?.name
                  }
                  onChange={handleChange("account")}
                  disabled={filteredAccounts?.length === 1}
                  label="Select Account"
                >
                  {filteredAccounts?.map(({ name }, index) => (
                    <MenuItem key={index} value={name}>
                      {name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {touched.account && errors.account && (
                <FormHelperText error>{errors.account}</FormHelperText>
              )}
            </div>
            {/* <div style={{ display: "flex" }}>
                  <div>
                   
                      <DatePicker
                        margin="none"
                        id="billing_history_start"
                        label="Start Date"
                        className="view-pdf__input"
                        format="MM/DD/YYYY"
                        value={startDate ? dayjs(startDate) : null}
                        KeyboardButtonProps={{
                          "aria-label": "pick date",
                        }}
                        autoOk
                        onChange={onStartDateChange}
                        error={dateError}
                        helperText={helperText}
                        slotProps={{
                          textField:{
                            fullWidth: true
                          }
                        }}
                      />
                   
                  </div>
                  <div style={{ marginLeft: "10px" }}>
                   
                      <DatePicker
                        margin="none"
                        id="billing_history_start"
                        label="End Date"
                        className="view-pdf__input"
                        format="MM/DD/YYYY"
                        value={endDate ? dayjs(endDate) : null}
                        KeyboardButtonProps={{
                          "aria-label": "pick date",
                        }}
                        autoOk
                        onChange={onEndDateChange}
                        slotProps={{
                          textField:{
                            fullWidth: true
                          }
                        }}

                      />
                   
                  </div>
                </div> */}
            <div className="view-pdf__button-container">
              <Button
                onClick={() => {
                  onClose();
                  resetForm();
                }}
                className="view-pdf__button"
                variant="outlined"
                color="secondary"
              >
                Cancel
              </Button>
              <SubmitButton
                handleClick={handleSubmit}
                buttonText="Download"
                className="view-pdf__button"
              />
            </div>
          </div>
        )}
      </Formik>
    </ModalWrapper>
  );
}
